const CallToAction = () => {
  const installHeights = () => {
    const callToActionBlocks = [...document.querySelectorAll(".call-to-action")];

    callToActionBlocks.forEach((block) => {
      const buttons = [...block.querySelectorAll(".btn")];
      
      if (buttons.length > 0) {
        buttons.forEach(button => {
          button.style.width = 'auto';
        });

        const maxWidth = Math.max(...buttons.map(button => {
          const style = window.getComputedStyle(button);
          const paddingLeft = parseFloat(style.paddingLeft);
          const paddingRight = parseFloat(style.paddingRight);
          return button.getBoundingClientRect().width + paddingLeft + paddingRight;
        }));

        buttons.forEach(button => {
          button.style.width = `${maxWidth}px`;
        });
      }
    });
  };

  window.addEventListener('resize', installHeights);
  
  installHeights();
}

export default CallToAction;
